import { Subscription, Observable, of } from 'rxjs';
import { tap, finalize } from "rxjs/operators";
import { Component, OnInit, ViewChild, OnDestroy, ViewChildren, QueryList, Input} from '@angular/core';
//import { RowNode, RedrawRowsParams } from "@ag-grid-enterprise/all-modules";
import { RowNode, RedrawRowsParams } from 'ag-grid-community';

import { FinancialAssuranceService } from '../../../../common/services/financial-assurance.service';
import { InternalUpcomingBondExpirationWidget } from './internal-upcoming-bond-expiration-widget.component';
import { FinancialAssuranceBondingComponent } from '../../../../common/components/financial-assurance/fa-bonding.component';
import { FinancialAssuranceInsuranceComponent } from '../../../../common/components/financial-assurance/fa-insurance.component';
import { FinancialAssurancePendingComponent } from '../../../../common/components/financial-assurance/fa-pending.component';
import { FinancialAssuranceListComponent } from '../../../../common/components/financial-assurance/fa-list.component';
import { InternalUpcomingInsuranceExpirationWidget } from './internal-upcoming-insurance-expiration-widget.component';
import { FinancialAssuranceReturnedFlowComponent } from '../../../../common/components/financial-assurance/fa-returned-flow.component';
import { FinancialAssuranceCompleteComponent } from '../../../../common/components/financial-assurance/fa-complete.component';
import { OrganizationComplianceDetails } from "../../../../common/models/organization.model";
import { OrganizationService } from '../../../../common/services/organization.service';
import { StratigraphicWellFinancialAssuranceView } from "../../../../common/models/financialAssurance.model";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";
import { LoaderService } from "../../../../common/services/loader.service";
import { TabComponent } from "../../../../common/components/tabs/tab.component";

@Component({
    selector: 'fa-internal-widget',
    templateUrl: './fa-internal-widget.component.html',
    standalone: false
})

export class FinancialAssuranceInternalWidget implements OnInit, OnDestroy {
    @Input() widgetTitle: string;


    @ViewChild(FinancialAssuranceListComponent, { static: true }) public _listGrid: FinancialAssuranceListComponent;
	@ViewChildren(FinancialAssurancePendingComponent) public _pendingGrid: QueryList<FinancialAssurancePendingComponent>;
    @ViewChild(FinancialAssuranceReturnedFlowComponent, { static: true }) public _returnedGrid: FinancialAssuranceReturnedFlowComponent;
    @ViewChild(InternalUpcomingBondExpirationWidget, { static: true }) public _upcomingBondExpirationGrid: InternalUpcomingBondExpirationWidget;
    @ViewChild(InternalUpcomingInsuranceExpirationWidget, { static: true }) public _upcomingInsuranceExpirationGrid: InternalUpcomingInsuranceExpirationWidget;
    @ViewChild(FinancialAssuranceCompleteComponent) public _completeGrid: FinancialAssuranceCompleteComponent;

    @ViewChild(FinancialAssuranceBondingComponent) public _bondingGrid: FinancialAssuranceBondingComponent;
    @ViewChild(FinancialAssuranceInsuranceComponent) public _insuranceGrid: FinancialAssuranceInsuranceComponent;

    faSummary: OrganizationComplianceDetails;
    orgId: string;
    templateIds = FinancialAssuranceService.TemplateIds;

    complianceData: OrganizationComplianceDetails[];

    isRecalculating: boolean = false;

    get displayDetailView(): boolean {
        return this.faSummary != null || this.isRecalculating;
    }

    _noBondingStratigraphicData: StratigraphicWellFinancialAssuranceView[];
    _stratigraphicData: StratigraphicWellFinancialAssuranceView[];

    get allStratigraphic(): StratigraphicWellFinancialAssuranceView[] {
        return this._stratigraphicData;
    }

    get noBondingStratigraphic(): StratigraphicWellFinancialAssuranceView[] {
        if (this._noBondingStratigraphicData == null) return null;
        return this._noBondingStratigraphicData;
        //return this._stratigraphicData.filter(s => s.bondingRequired == null || s.bondingRequired == 0);
    }

    subscriptions: Subscription = new Subscription();

    constructor(private service: OrganizationService, private dataService: FinancialAssuranceService, private dialog: DynamicDialogService, private loader: LoaderService ) { }

    ngOnInit() {
        let dataObs$: Observable<OrganizationComplianceDetails[]> = this._listGrid.dataObservable;
        let subs$ = dataObs$.pipe(
            tap((details: OrganizationComplianceDetails[]) => { this.complianceData = details; })
        ).subscribe(
            (d: OrganizationComplianceDetails[]) => {  },
            (error) => { console.error(error); }
        );
        this.subscriptions.add(subs$);
        
    }

    ngOnDestroy() {
        if (this.subscriptions != null) this.subscriptions.unsubscribe();
    }


    hideDetail(): void {
        this.faSummary = undefined;
        this.orgId = undefined;
    }

    onDetailTabClicked(): void {
        this._bondingGrid.resizeColumns();
        this._insuranceGrid.resizeColumns();
    }

    onTabClicked(tab: TabComponent): void {
        if (tab.title.includes("Stratigraphic")) {
            let strat$: Observable<StratigraphicWellFinancialAssuranceView[]>;
            if (this._stratigraphicData != null && this._stratigraphicData.length > 0) {
                strat$ = of(this._stratigraphicData);
            } else {
                this.loader.toggleLoader(true);
                strat$ = this.dataService.getStratigraphicBondingSummary().pipe(
                    tap((data: StratigraphicWellFinancialAssuranceView[]) => {
                        this._stratigraphicData = data;
                        this._noBondingStratigraphicData = data.filter(s => s.bondingRequired == null || s.bondingRequired == 0)
                        console.log("strat summary load complete");
                    })
                );
            }
            let stratSub$: Subscription = strat$.subscribe(
                () => {
                    this.loader.toggleLoader(false);
                },
                (error) => {
                    console.error('error in strat summary load', error);
                    this.loader.toggleLoader(false);
                    this.dialog.showError();
                }
            )
            this.subscriptions.add(stratSub$);
        } else {
            this._listGrid.resizeColumns();
			this._pendingGrid.forEach(grid => grid.resizeColumns());
            this._upcomingBondExpirationGrid.resizeColumns();
            this._upcomingInsuranceExpirationGrid.resizeColumns();
            this._returnedGrid.resizeColumns();
            this._completeGrid.resizeColumns();
        }      
    }

    recalculate(organization: string): void {
        if (this.isRecalculating === false) {
            this.faSummary = null;
            this.isRecalculating = true;
            let detail$ = this.service.updateCompliance(organization).pipe(
                tap((summary: OrganizationComplianceDetails) => {
                    this.faSummary = summary;
                }),
                finalize(() => { this.isRecalculating = false; })
            ).subscribe(
                () => {
                    this.isRecalculating = false;
                    if (this.faSummary != null) this.updateRow();
                },
                (error) => { console.error(error); }
            );
            this.subscriptions.add(detail$);
        }
    }

    showDetail(orgId: string): void {
        const faSummary = this._listGrid.rows.find(summary => summary.orgId === orgId);
        if (faSummary) {
            this.orgId = orgId;
            this.faSummary = (faSummary);
        } else {
            this.faSummary = null;
        }
    }

    updateRow(): void {
        let index = this._listGrid.rows.findIndex(s => s.orgId == this.faSummary.orgId);
        if (index != -1) {
            this._listGrid.rows.splice(index, 1, this.faSummary);
            let nodes: RowNode[] = [];
            this._listGrid.gridApi.forEachNode(n => {
                if (n.data != null) {
                    let obj = <OrganizationComplianceDetails>n.data;
                    if (obj.orgId == this.faSummary.orgId) {
                        n.data = this.faSummary;
                        nodes.push(n as RowNode);
                    }
                }
            });
            this._listGrid.data.next(this._listGrid.rows);
            this._listGrid.gridApi.redrawRows(<RedrawRowsParams>{ rowNodes: nodes });
        }
    }

}
